import React, { Component } from "react";
import {
  Button,
  Grid,
  Header,
  List,
  Segment,
  Message,
  Form
} from "semantic-ui-react";
import { BrowserRouter as Router, Link, Route } from "react-router-dom";
import ContactUs from "./ContactUs";
import DevCard from "./DevCard";
import PageHeader from "./components/PageHeader";
import PromoCard from "./components/PromoCard";

import styled from "styled-components";

const text = `Gluten Free Labs is a website and mobile app development company located in Chicago. Our agency provides both iOS and android app design, development, and maintenance services. Our staff is experienced in the development of cross-platform applications for web and mobile users. We design and develop mobile apps to extend your message on Apple and Android handheld, tablet and wearable devices. We create apps that can be used privately in the enterprise or publicly available in iTunes and Google Play stores.`;
const text2 = `A mobile web application and/or mobile apps are the most beneficial way to improve customer engagement, increase brand recognition and cultivate customer loyalty. We specialize in developing web and mobile experiences that include multiple user roles, complex databases and web administration panels with real-time web services that keep your iOS and Android apps in sync.`;
const text3 = `Gluten Free Labs can help you design and develop your mobile app, a custom responsive website, and your SEO marketing strategy. Our agency is your one-stop-shop to fulfill all your design, development and marketing needs. Your complete satisfaction with our mobile, web and SEO services is paramount to our success. We look forward to working with you!`;

const Label = styled.h1`
  padding-top: 10px;
  font-size: 1.4em;
  text-align: center;
  color: #34495e;
  font-weight: 400;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

const data = [
  {
    title: "Mobile Apps",
    description:
      "We design and develop beautiful iOS and Android handheld and tablet apps. Our team has a relentless focus on app design and app development standards.",
    icon: "mobile alternate"
  },
  {
    title: "Websites",
    description:
      "Our website team designs and develops responsive websites and web applications optimized for end users and their web and mobile devices.",
    icon: "desktop"
  },
  {
    title: "SEO Services",
    description:
      "We create and manage Search Engine Optimization campaigns that make your website find-able; driving quality website sessions and conversions.",
    icon: "chart line"
  }
];
class Home extends Component {
  render() {
    const headerColor = "#2c3e50";
    const featureColor = "violet";
    return (
      <div
        style={{
          padding: 50
        }}
      >
        <PageHeader
          image={require("./resources/logo.png")}
          title={"GLUTEN FREE LABS"}
          subTitle={
            "CREATING MARKETABLE WEB & MOBILE APP EXPERIENCES SINCE 2004."
          }
        />
        <Label>{text} </Label>
        <Label>{text2} </Label>
        <Label>{text3} </Label>
        <div class="ui stackable grid" style={{ paddingTop: 100 }}>
          <div class="three column row">
            <div class="column">
              <PromoCard
                name={data[0].title}
                description={data[0].description}
                icon={data[0].icon}
              />
            </div>
            <div class="column">
              <PromoCard
                name={data[1].title}
                description={data[1].description}
                icon={data[1].icon}
              />
            </div>
            <div class="column">
              <PromoCard
                name={data[2].title}
                description={data[2].description}
                icon={data[2].icon}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  doubleFont: {
    fontSize: "1.5rem",
    fontFamily: "Helvetica Neue",
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 30
  }
};

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js